import React from 'react'
import './AboutContent.css'

function AboutContent() {
  return (
    <div className='about-content'>
        <h2>About Us</h2>
        <p>Recycool is a student-centered marketplace designed to bring sustainable trading to campus. Our platform connects students looking to buy or sell items—from textbooks and gadgets to fashion and furniture—within a trusted college network. We believe in reducing waste and making quality items accessible to everyone. With Recycool, students can easily browse listings, contact sellers, and complete transactions safely within the college community. Our mission is to promote sustainability and affordability, creating a circular economy where students can benefit financially while supporting an eco-friendly lifestyle. Join us in building a smarter, greener campus with Recycool!</p>
    </div>
  )
}

export default AboutContent